import { useTranslation } from "react-i18next";
import { navigateToUrl } from "single-spa";
import { TypographyComponent, TextLinkComponent } from "@gx1/gx-ui-common";
import GartnerBuySmartLogoSVG from "../../../assets/images/gartner-buy-smart-logo.svg";
import styles from "./freetrial-expired-token.styles.module.scss";

const FreeTrialExpiredTokenComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.messageContainer}>
      <div className={styles.imgContainer}>
        <img alt={t("Gartner BuySmart logo")} src={GartnerBuySmartLogoSVG} />
      </div>
      <TypographyComponent styling="h3" color="white" boldness={"semi"} element={"h1"}>
        {t(
          "Your invitation link to a BuySmart free trial has expired. If you need further assistance, please contact us at the address below."
        )}
      </TypographyComponent>
      <div className={styles.dividerLine} />
      <div className={styles.buttonWrapper}>
        <TextLinkComponent
          theme={"dark"}
          href="/login"
          onClick={() => navigateToUrl("/login")}
          text={t(`Log Into BuySmart`)}
        />
        <div className={styles.verticalLine} />
        <TextLinkComponent
          theme={"dark"}
          href="mailto:buysmart@gartner.com"
          onClick={() => window.open("mailto:buysmart@gartner.com", "_self")}
          text={t(`Contact BuySmart@Gartner.com`)}
        />
      </div>
    </div>
  );
};

export default FreeTrialExpiredTokenComponent;
